import { fetchWrapper } from "./fetchWrapper";
import { GingerMediaBaseUrl } from "./baseUrls";

export async function attachImageUrlToMediaData(service: string, gmgAssetCode: string, fileUrl: string | null) {
    return fetchWrapper(`${GingerMediaBaseUrl}/attachImageUrlToMediaData?serviceId=${service}&gmgAssetCode=${gmgAssetCode}`, {
        method: 'POST',
        body: { fileUrl }
    });
}